import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * プロジェクト事例のPDF画像枚数を表示するコンポーネント
 * @constructor
 */
export const CSearchSolutionPdfImageCountText = (props) => {
    const { className = '', count } = props;
    return (_jsxs("div", Object.assign({ className: clsx('inline-flex gap-x-4', className) }, { children: [_jsx(Text, Object.assign({ size: 'sm' }, { children: "\u8CC7\u6599\u63B2\u8F09\u679A\u6570\uFF1A" })), _jsx(Text, Object.assign({ color: 'link', isBold: true, size: 'sm' }, { children: count })), _jsx(Text, Object.assign({ size: 'sm' }, { children: "\u30DA\u30FC\u30B8" }))] })));
};
